module.exports = __webpack_public_path__ + "static/media/Group 1533.6f5af1ff.svg";